import React from 'react';
import IsoHero from '../components/IsoHero';
import IsoDetails from '../components/IsoDetails';

const IsoCertificationPage = () => {
  return (
    <div className="gfi-iso-page-wrapper">
      
      {/* 1. INITIAL CLEAN WIDE INNER HERO BANNER LAYOUT BLOCK */}
      <IsoHero />
      <IsoDetails />
      
      {/* 2. Future ISO Document Viewers Aur Parameters Details Yahan Par Add Honge */}

    </div>
  );
};

export default IsoCertificationPage;